export const nav = {
    dashboard: 'dashboard',
    commissions: 'commissions',
    carriers: 'carriers',
    customers: 'customers',
    invoicing: 'invoicing',
    offers: 'offers',
    profile: 'profile',
} as const;
